import { Component, OnInit } from '@angular/core';
import { TarifNameService } from '../../tarifs/tarif-name.service';
import { ProductTarifService } from '../product-tarif.service'
import { ProductStorageService } from '../../product_storages/product-storage.service'
import { CategoryService } from '../../categories/category.service';
import { Router } from '@angular/router';
import { OverlayPanelModule } from 'primeng/primeng';
import { Message } from 'primeng/primeng';


export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}


@Component({
  selector: 'app-product-tarif',
  templateUrl: './product-tarif.component.html',
  styleUrls: ['./product-tarif.component.css'],
  providers: [
    TarifNameService,
    ProductTarifService,
    ProductStorageService,
    CategoryService
  ]
  // encapsulation: ViewEncapsulation.None
})
export class ProductTarifComponent implements OnInit {

  id:any = null;
  productTarifs: any[] = [];
  productTarifChild: any[] = [];
  productTarifChildCriteria: any[] = [];
  msgs: Message[] = [];

  selectedProducts: any[];
  loading: boolean = false;
  productTarifChildDialog: boolean = false;
  productTarifChildLoading: boolean = false;
  tariff_id: string;
  categoryFetch: any = [];
  categories: any = [];
  searchSku: string = "";
  searchName: string = "";
  searchFilterSimple: any = [];
  searchCategory: string = "";

  searchFilter: any = [];

  searchColumn: any = [];
  tarifNameList: any = [];

  pagination: Pagination;

  selectProductTarifChildDialog: boolean = false;
  selectProductTarifChildLoading: boolean = false;
  selectProductTarifChild: any[] = [];



  constructor(
    private router: Router,
    private productTarifService: ProductTarifService,
    private productStorageService: ProductStorageService,
    private categoryService: CategoryService,
    private tarifNameService: TarifNameService
  ) { }

  ngOnInit() {

    this.fillSearchColumn();

    this.pagination = {
      current_page: 1,
      per_page: 1,
      last_page: 1
    }

    this.loading = true;
    this.tarifNameService.getTarifName().subscribe(response => { this.productTarifs = response['data']; this.loading = false; });

    this.categoryService.getCategory().subscribe(response => {
      this.recarray(response['data'], 'children', this);
      this.categories = this.categoryFetch.map(function (value: any) {
        return { label: value.name, value: value.id };
      });
      this.loading = false;
    });

    this.init();

  }

  fillSearchColumn() {
    this.searchColumn = [];
    this.searchColumn.push({ label: "Название", value: { column: "tariff_name_id", type: "dropdown", value: this.tarifNameList } });
    console.log('this.searchColumn');
    console.log(this.searchColumn);
  }
  setFilter(data) {
    this.searchFilter = data;
    this.loading = true;
    this.tarifNameService.getTarifNameByFilter(this.searchFilter).subscribe(response => { this.productTarifs = response['data']; this.loading = false; });
  }

  init() {
    this.tarifNameService.getTarifName().subscribe(response => {

      this.tarifNameList = response['data'].map(value => {
        return { label: value.name, value: { value: value.id, label: value.name } };
      })
      console.log('this.tarifNameList');
      console.log(this.tarifNameList);
      this.fillSearchColumn();
    });
  }

  recarray(ar: any, searchfor: any, that: any) {
    ar.forEach(function (item: any, i: any, arr: any) {
      if (item instanceof Object) {
        if ("children" in item) {
          that.recarray(item['children'], searchfor, that)
        }
        that.categoryFetch.push(item);
      }
    });
  }


  show(id): void {
    
    this.id=id;
    this.productTarifChild = [];
    this.productTarifChildDialog = true;
    this.productTarifChildLoading = true;

    this.productTarifService.getProductTarifByTariffNameId(id).subscribe(response => {
      this.productTarifChild = response['data'];
      this.productTarifChildLoading = false;
    });
  }

  onShowCriteria(data) {
    this.productTarifChildCriteria = data['value'];
    console.log(this.productTarifChildCriteria);
  }
  add(id): void {
    this.router.navigate(['/dashboard/product-tarif-crud/', { tarif_name_id: id }]);
  }

  onAddProductToTarifChild(id) {
    this.selectProductTarifChild = [];
    this.tariff_id = id;
    this.selectProductTarifChildDialog = true;
    this.onSearch(1);
    this.productTarifService.getProductTarifSelectedProducts(id).subscribe(response => { this.selectedProducts = response['data']['products'].map(data => { return data }); console.log(this.selectedProducts) })
  }

 

  onSelectProductTarifChild(value:any="") {

    let data = {
      tariff_id: this.tariff_id,
      product_storage_ids: this.selectedProducts.map(data => { return data.id })
    }

    this.productTarifService.attachProductTarif(data).subscribe(response => { 
      
      this.selectProductTarifChildDialog = false; 
      this.productTarifChildLoading = true;
      
      this.productTarifService.getProductTarifByTariffNameId(this.id).subscribe(response => {
        this.productTarifChild = response['data'];
        this.productTarifChildLoading = false;
      });
      
    }, (error) => {
      let str = "";
      this.productTarifChildLoading = false;
      this.selectProductTarifChildDialog = false; 
      if (!error.error.errors) {
        str = error.error.message;
      }
      for (let item in error.error.errors) {
        str += "\n" + error.error.errors[item][0];
      }
      this.msgs.push({ severity: 'error', summary: 'Сообщение', detail: "Ошибка: " + str });
    });

    
  }


  editProductTarifChild(id) {
    this.router.navigate(['/dashboard/product-tarif-crud/', { tariff_id: id }]);
  }

  onPaginate(event) {
    event.page = event.page + 1
    this.onSearch(event.page);
  }

  onSearch(page = 0) {
    let attribute = "";
    let value = "";
    this.selectProductTarifChildLoading = true;
    if (this.searchSku) {
      this.searchFilterSimple.push({ name: 'sku', value: this.searchSku })
    }
    if (this.searchName) {
      this.searchFilterSimple.push({ name: 'name', value: this.searchName })
    }
    if (this.searchCategory) {
      this.searchFilterSimple.push({ name: 'category_id', value: this.searchCategory })
    }
     console.log(this.searchFilterSimple);
    this.productStorageService.getProductStorageByFilter(this.searchFilterSimple, page).subscribe(response => {
      this.searchFilterSimple = [];
      this.pagination = response['pagination'] || {current_page: 1,per_page: 1,last_page: 1};
      this.selectProductTarifChild = response['data']
      this.selectProductTarifChildLoading = false;
    });

  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/product_tarifs/product-tarif/product-tarif.component.ts